/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {DamShare} from 'compob2b-libs';
import {translations} from '../../../../environments/translations.ru';
import {CreateUpdateComponent} from '../../../admin-shared/crud-components/create-update/create-update.component';
import {CrudConfig} from '../../../admin-shared/interfaces/crud.config';
import {DAM_SHARE_FORM} from './dam-share-forms.config';

@Component({
    templateUrl: './dam-share.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DamShareComponent extends CreateUpdateComponent<DamShare> implements OnInit {

  shareUrl = '';
  isModal = true;
  protected entity: any;

  config: CrudConfig = {
    uri: '/dam-share/items',
    columns: DAM_SHARE_FORM,
    title: 'Поделиться',
    absolutePath: '/cabinet/dam-share',
  };

  @Input()
  damItems: number[] = [];

  @Input()
  damCatalog: number;

  @Input()
  shareType: number;

  ngOnInit(): void {
    super.setConfig(this.config);
    super.ngOnInit();
    this.redirectToEditPage = true;
  }

  beforeSubmit(): void {
    super.beforeSubmit();
    this.entity.damCatalogId = this.damCatalog;
    this.entity.shareType = this.shareType;
    this.entity.damItems = Array.from(this.damItems);

    console.log(this.entity);
  }

  afterSubmit(): void {
    this.shareUrl = this.createdId;
    this.cdr.detectChanges();
  }

  copyShareUrl() {
    navigator.clipboard.writeText(this.shareUrl).then(_ => {
      this.successToast(translations.copiedToClipboard);
    });
  }
}
